import { z } from 'zod';
import { sizeSchema, coordinateSchema } from '../../../Shared.js';
import { numberSchema } from '../schemas.js';

var HotspotIconPosition = /* @__PURE__ */ ((HotspotIconPosition2) => {
  HotspotIconPosition2["TOP_LEFT"] = "top:left";
  HotspotIconPosition2["TOP_RIGHT"] = "top:right";
  HotspotIconPosition2["BOTTOM_LEFT"] = "bottom:left";
  HotspotIconPosition2["BOTTOM_RIGHT"] = "bottom:right";
  return HotspotIconPosition2;
})(HotspotIconPosition || {});
const baseSchema = z.object({
  id: z.string(),
  position: coordinateSchema,
  size: sizeSchema,
  style: z.object({
    icon: z.object({
      enabled: z.boolean(),
      position: z.enum(["top:left", "top:right", "bottom:left", "bottom:right"]).default("bottom:right")
    }),
    background: z.object({
      color: z.string(),
      opacity: z.number().optional()
    }).optional(),
    border: z.object({
      style: z.string(),
      width: numberSchema(1),
      color: z.string(),
      radius: z.number().optional()
    }).optional()
  }).nullish().default({ icon: { enabled: false, position: "bottom:right" } })
});
const linkHotspotItemSchema = baseSchema.extend({
  kind: z.literal("linkHotspot"),
  href: z.string()
});
const speechHotspotItemSchema = baseSchema.extend({
  kind: z.literal("speechHotspot"),
  text: z.string().default(""),
  language: z.enum(["none", "da", "en", "fr", "de", "es"]).optional()
});
const hotspotItemSchema = z.discriminatedUnion("kind", [
  linkHotspotItemSchema,
  speechHotspotItemSchema
]);

export { HotspotIconPosition, hotspotItemSchema };
//# sourceMappingURL=Hotspot.js.map
